import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MultiSelectModule } from 'primeng/multiselect';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {APP_BASE_HREF} from '@angular/common';
import { AppLayoutModule } from './layout/app.layout.module';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { HomeComponent } from './pages/portal/home/home.component';
import { ListComponent } from './pages/portal/vendor/list/list.component';
import { TreeTableModule } from 'primeng/treetable';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule} from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { ShipmentComponent } from './pages/portal/order/shipment/shipment.component';
import { ScheduleComponent } from './pages/portal/order/schedule/schedule.component';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { RegistrationComponent } from './pages/portal/vendor/registration/registration.component';
import { StepsModule } from 'primeng/steps';
import { ToastModule } from 'primeng/toast';
import { AccordionModule } from 'primeng/accordion';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { CheckboxModule } from 'primeng/checkbox';
import { VendorNotFoundComponent } from './pages/portal/vendor-not-found/vendor-not-found.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ImageModule } from 'primeng/image';
import { ViewPurchaseOrderComponent } from './pages/portal/purchase-order/view-purchase-order/view-purchase-order.component';
import { VendorDetailComponent } from './pages/portal/vendor/vendor-detail/vendor-detail.component';
import { CreateShipmentAsnComponent } from './pages/portal/shimpent-asn/create-shipment-asn/create-shipment-asn.component';
import { CardModule } from 'primeng/card';
import { ProcessShimpentAsnComponent } from './pages/portal/shimpent-asn/process-shimpent-asn/process-shimpent-asn.component';
import { VendorDetailByIdComponent } from './pages/portal/vendor/vendor-detail-by-id/vendor-detail-by-id.component';
import { TokenComponent } from './pages/portal/order/token/token.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { GateInComponent } from './pages/portal/gate-management/gate-in/gate-in.component';
import { GateOutComponent } from './pages/portal/gate-management/gate-out/gate-out.component';
import { TabViewModule } from 'primeng/tabview';
import { VisitorPassComponent } from './pages/portal/gate-management/visitor-pass/visitor-pass.component';
import { SidebarModule } from 'primeng/sidebar';
import { GrComponent } from './pages/portal/gr-ir/gr/gr.component';
import { IrComponent } from './pages/portal/gr-ir/ir/ir.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ChartModule } from 'primeng/chart';
import { AddVendorUserComponent } from './pages/portal/vendor/add-vendor-user/add-vendor-user.component';
import { ApproveVendorListComponent } from './pages/portal/vendor/approve-vendor-list/approve-vendor-list.component';
import { PendingVendorListComponent } from './pages/portal/vendor/pending-vendor-list/pending-vendor-list.component';
import { PendingVendorApprovalComponent } from './pages/portal/vendor/pending-vendor-approval/pending-vendor-approval.component';
import { ProfileComponent } from './pages/portal/profile/profile.component';
import { ChangeRequestComponent } from './pages/portal/vendor/change-request/change-request.component';
import { ViewPaymentComponent } from './pages/portal/payment/view-payment/view-payment.component';
import { VendorDetailCardComponent } from './pages/portal/vendor/vendor-detail-card/vendor-detail-card.component';
import { PaginatorModule } from 'primeng/paginator';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { DeleiveryBarComponent } from './pages/portal/order/deleivery-bar/deleivery-bar.component';
import { PendingReviewComponent } from './pages/portal/vendor/pending-review/pending-review.component';
import { VisitorGateOutPassComponent } from './pages/portal/gate-management/visitor-gate-out-pass/visitor-gate-out-pass.component';
import { LoadingScreenComponent } from './pages/loading-screen/loading-screen.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChangeDetailComponent } from './pages/portal/vendor/change-detail/change-detail.component';
import { PendingChangeRequestComponent } from './pages/portal/vendor/pending-change-request/pending-change-request.component';
import { ViewVendorDetailsComponent } from './pages/portal/vendor/view-vendor-details/view-vendor-details.component';
import { GrLineItemComponent } from './pages/portal/gr-ir/gr-line-item/gr-line-item.component';
import { VendorBlackListComponent } from './pages/portal/vendor/vendor-black-list/vendor-black-list.component';
import { AddUserRoleComponent } from './pages/portal/vendor/add-user-role/add-user-role.component';
import { AddUserCreationComponent } from './pages/portal/vendor/add-user-creation/add-user-creation.component';
import { ViewReconciliationComponent } from './pages/portal/vendor/view-reconciliation/view-reconciliation.component';
import { VendorBlackLegalListComponent } from './pages/portal/vendor/vendor-black-legal-list/vendor-black-legal-list.component';
import { RejectVendorListComponent } from './pages/portal/vendor/reject-vendor-list/reject-vendor-list.component';
import { VendorQueryListComponent } from './pages/portal/vendor/vendor-query-list/vendor-query-list.component';
import { PasswordModule } from 'primeng/password';
import { ChangeDetailHistoryComponent } from './pages/portal/vendor/change-detail-history/change-detail-history.component';
import { UploadInvoiceComponent } from './pages/upload-invoice/upload-invoice.component';

@NgModule({
  declarations: [
    AppComponent,
    NotfoundComponent,
    HomeComponent,
    RegistrationComponent,
    ListComponent,
    ScheduleComponent,
    ShipmentComponent,
    ViewPurchaseOrderComponent,
    VendorNotFoundComponent,
    VendorDetailComponent,
    CreateShipmentAsnComponent,
    ProcessShimpentAsnComponent,
    VendorDetailByIdComponent,
    TokenComponent,
    GateInComponent,
    GateOutComponent,
    VisitorPassComponent,
    GrComponent,
    IrComponent,
    AddVendorUserComponent,
    ApproveVendorListComponent,
    PendingVendorListComponent,
    PendingVendorApprovalComponent,
    ProfileComponent,
    PendingVendorApprovalComponent,
    ChangeRequestComponent,
    ViewPaymentComponent,
    VendorDetailCardComponent,
    DeleiveryBarComponent,
    PendingReviewComponent,
    VisitorGateOutPassComponent,
    LoadingScreenComponent,
    ChangeDetailComponent,
    PendingChangeRequestComponent,
    ViewVendorDetailsComponent,
    GrLineItemComponent,
    VendorBlackListComponent,
    AddUserRoleComponent,
    AddUserCreationComponent,
    ViewReconciliationComponent,
    VendorBlackLegalListComponent,
    RejectVendorListComponent,
    VendorQueryListComponent,
    ChangeDetailHistoryComponent,
    UploadInvoiceComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppLayoutModule,
    TreeTableModule,
    ButtonModule,
    HttpClientModule,
    TableModule,
    MultiSelectModule,
    StepsModule,
    ToastModule,
    AccordionModule,
    FormsModule,
    DropdownModule,
    FileUploadModule,
    CheckboxModule,
    InputTextModule,
    ReactiveFormsModule,
    SelectButtonModule,
    ConfirmDialogModule,
    DialogModule,
    CalendarModule,
    TooltipModule,
    InputNumberModule,
    TagModule,
    ImageModule,
    CardModule,
    RadioButtonModule,
    TabViewModule,
    SidebarModule,
    AutoCompleteModule,
    ChartModule,
    PaginatorModule,
    AvatarModule,
    AvatarGroupModule,
    ProgressSpinnerModule,
    PasswordModule
  ],
  providers: [{provide: APP_BASE_HREF, useValue: '/vendorapp'},DatePipe,MessageService,ConfirmationService],
  bootstrap: [AppComponent]
})
export class AppModule { }
